
import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { NavService, Menu } from '../../services/nav.service';
import { FeatherIconsComponent } from '../feather-icons/feather-icons.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { LogoService } from '../../../_services/logo.service';
import { ProfileService } from '../../../_services/ProfileServices/profile.service';
import { IconPipe } from "../../services/icon.pipe";
import { HasClaimDirective } from '@app/directives/has-claim.directive';
import { CLAIMS } from '@app/shared/utilities/constants';
import { UserAuthDto } from '@app/shared/model/user.model';
import { AuthService } from '@app/_services/auth/auth.service';
import { HttpResponse } from '@angular/common/http';
import { ApiRequestService } from '@app/_services/api-Services/api-request.service';
import { LoadingService } from '@app/_services/LoadingService/loading.service';
import { EmployeeDto } from '@app/shared/model/employee.model';
import { ToastrService } from 'ngx-toastr';
import { FontAwsomeIconsComponent } from '../font-awsome-icons/font-awsome-icons.component';
import * as CryptoJS from 'crypto-js';
@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    CommonModule,
     RouterModule,
      FeatherIconsComponent,
       NgbModule,
        TranslateModule,
         HasClaimDirective
        ],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  public readonly CLAIMS = CLAIMS;
  public menuItems: Menu[] | any;
  public url: any;
  public fileurl: any;
  logo! : string;
  UserCode: string;
  UserName: string;
  UserRole : string;
  UserEmail : string;
  user!: UserAuthDto;
  selectedEmployee: EmployeeDto | null = null;
  personUserName!: string;
  personFullName!: string;
  isSuperAdmin : boolean = false;
  superAdmin : string;
  constructor(
    private router: Router,
     public navServices: NavService,
     private userauth: AuthService,
     private loaderService: LoadingService,
     private toastrService: ToastrService,
     private apiRequestService: ApiRequestService,
    ) {

      const encryptedIsSuperAdmin = localStorage.getItem('odIjHu1fB0TQIK4QTNOm6A=='); 
      if (encryptedIsSuperAdmin) 
        { 
          const decryptedBytes = CryptoJS.AES.decrypt(encryptedIsSuperAdmin, 'P6A~zSE2Z9%c'); 
          const decryptedIsSuperAdmin = decryptedBytes.toString(CryptoJS.enc.Utf8);
          this.isSuperAdmin = decryptedIsSuperAdmin === 'true'; 
        } 
        else 
        { 
          this.isSuperAdmin = false; 
        }
      
      // Get user data from currentUser stored during authentication
      const currentUser = this.userauth.getCurrentUserValue();
      this.personUserName = currentUser?.emailAddress || 'DefaultUserName';
      this.personFullName = currentUser?.fullName || 'Default Name';
    // Subscribe to the menu items from NavService
    
  this.navServices.items.subscribe(menuItems => {
    if (menuItems && menuItems.length > 0) {
      this.menuItems = menuItems;

      // Subscribe to router events to track active menu items
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          menuItems.filter(items => {
            if (items.path === event.url)
              this.setNavActive(items)
            if (!items.children) return false
            items.children.filter(subItems => {
              if (subItems.path === event.url)
                this.setNavActive(subItems)
              if (!subItems.children) return false
              subItems.children.filter(subSubItems => {
                if (subSubItems.path === event.url)
                  this.setNavActive(subSubItems)
              })
              return
            })
            return
          }
          )
        }
      })
    }
  });
  
}




  ngOnInit(): void {
    this.user = this.userauth.getCurrentUserValue() || ({} as UserAuthDto);
  }

  logIcon(icon: string) {
    //console.log('Icon:', icon);
  }

  setActiveMenuItem(url: string) {
    this.menuItems.forEach((item: Menu) => {
      if (item.path === url) {
        item.active = true;
      } else {
        item.active = false;
      }
    });
  }

  setNavActive(item:any) {
    this.menuItems.filter((menuItem:any) => {
      if (menuItem != item)
        menuItem.active = false
      if (menuItem.children && menuItem.children.includes(item))
        menuItem.active = true
      if (menuItem.children) {
        menuItem.children.filter((submenuItems:any) => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true
            submenuItems.active = true
          }
        })
      }
    })
  }

  // Active Nave state
  // setNavActive(item: Menu) {
  //   this.menuItems.forEach((menuItem: any) => {
  //     menuItem.active = false;
  //     if (menuItem.children) {
  //       menuItem.children.forEach((subItem: any) => subItem.active = false);
  //     }
  //   });
  //   item.active = true;
  //   if (item.children) {
  //     item.children.forEach(subItem => subItem.active = true);
  //   }
  //   this.menuItems.forEach((menuItem: any) => {
  //     if (menuItem.children && menuItem.children.includes(item)) {
  //       menuItem.active = true;
  //     }
  //   });
  // }

  // Click Toggle menu
  // toggleNavActive(item: Menu) {
  //   item.active = !item.active;
  // }


  // toggleNavActive(item: Menu) {
  //   // Toggle the active state for the parent (collapsible) menu
  //   if (item.type === 'sub') {
  //     item.active = !item.active;
  //   }
  //   this.menuItems.forEach((menuItem: any) => {
  //     if (menuItem !== item && menuItem.type === 'sub') {
  //       menuItem.active = false;
  //     }
  //   });
  // }

  toggleNavActive(item:any) {
    if (!item.active) {
      this.menuItems.forEach((a:any) => {
        if (this.menuItems.includes(item))
          a.active = false
        if (!a.children) return false
        a.children.forEach((b:any) => {
          if (a.children.includes(item)) {
            b.active = false
          }
        })
        return
      });
    }
    item.active = !item.active
  }

  logItemDetails(item: Menu) {
    console.log('Breadcrumb:', item.title);
    console.log('ClaimType:', item.claimType);
  }

  //Fileupload
  readUrl(event: any) {
    if (event.target.files.length === 0)
      return;
    //Image upload validation
    var mimeType = event.target.files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }
    // Image upload
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      this.url = reader.result;
    }
  }

  

}
